import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=b2af95fc"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2af95fc')) {
      api.createRecord('b2af95fc', component.options)
    } else {
      api.reload('b2af95fc', component.options)
    }
    module.hot.accept("./Consent.vue?vue&type=template&id=b2af95fc", function () {
      api.rerender('b2af95fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/Consent.vue"
export default component.exports